import Shape from "./Shape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import makerjs, {IModel} from "makerjs";
import {createModelFromShape} from "../../../../source/js/shared/rendering/makerjs";

export default class RoundedRectangle extends Shape {

	getOffsetModel( offset: Length ): IModel {
		const enclosed = makerjs.measure.modelExtents( this.parentModel );
		const enclosedRectangle = createModelFromShape(
			'rectangle',
			{ length: enclosed.width, width: enclosed.height }
		);

		if ( offset.in_cm() <= 0 ) {
			return { models: { 0: enclosedRectangle } };
		}

		return makerjs.model.outline( enclosedRectangle, offset.in_cm(), 1, true );
	}
}
